define((require) => {
    "use strict";

    var ImprovedView = require("editor/zbone/ImprovedView"),
        template     = require("ui/zendesk/ZendeskErrorView.tpl");

    /**
     * The Zendesk Support Tab Error view.
     *
     * @class ZendeskErrorView
     * @constructor
     */
    return ImprovedView.extend({

        template: template

    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/zendesk/ZendeskErrorView.js